// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_poi.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { AdminPoiService } from "./admin_poi_pb";

/**
 * ListAdminPois returns a page of a city's places, from any source, filtered.
 *
 * @generated from rpc travplaces.v1.AdminPoiService.ListAdminPois
 */
export const listAdminPois = AdminPoiService.method.listAdminPois;

/**
 * PoiCounts returns per-category counts by source, for reviewing provenance.
 *
 * @generated from rpc travplaces.v1.AdminPoiService.PoiCounts
 */
export const poiCounts = AdminPoiService.method.poiCounts;

/**
 * CreatePoi adds a hand-entered place (source = manual).
 *
 * @generated from rpc travplaces.v1.AdminPoiService.CreatePoi
 */
export const createPoi = AdminPoiService.method.createPoi;

/**
 * UpdatePoi edits a manual place.
 *
 * @generated from rpc travplaces.v1.AdminPoiService.UpdatePoi
 */
export const updatePoi = AdminPoiService.method.updatePoi;

/**
 * DeletePoi removes a manual place.
 *
 * @generated from rpc travplaces.v1.AdminPoiService.DeletePoi
 */
export const deletePoi = AdminPoiService.method.deletePoi;

/**
 * PoiDuplicates reports what a proposed place might duplicate, writing nothing.
 *
 * @generated from rpc travplaces.v1.AdminPoiService.PoiDuplicates
 */
export const poiDuplicates = AdminPoiService.method.poiDuplicates;
